import { Box } from "@mui/material";
import useWavesurfer from "./useWaveSurfer";
import React, { useEffect, useRef, useCallback } from "react";
import "./index.scss";

export default function WavePlayerFeed({
  url,
  handlePlay,
  handlePause,
  handleCurrentTime,
  handleEnd,
  handleSeek,
  sampleData,
  volume,
  showAdv,
  playing,
}) {
  const containerRef = useRef();
  const wavesurfer = useWavesurfer(containerRef, url, sampleData);

  // Set volume when it changes
  useEffect(() => {
    if (wavesurfer) {
      wavesurfer.setVolume(volume / 100);
    }
  }, [volume, wavesurfer]);

  // Play/pause based on prop, but only if state changes
  useEffect(() => {
    if (!wavesurfer) return;
    if (playing && !wavesurfer.isPlaying()) {
      wavesurfer.play().catch((e) => {
        if (e.name !== "AbortError") console.error(e);
      });
    } else if (!playing && wavesurfer.isPlaying()) {
      wavesurfer.pause();
    }
  }, [playing, wavesurfer]);

  // Handle showAdv changes if needed
  useEffect(() => {
    if (!wavesurfer) return;
    // If you want to auto-play on showAdv, you can trigger play here
    // wavesurfer.play();
  }, [showAdv, wavesurfer]);

  // Subscribe to wavesurfer events
  useEffect(() => {
    if (!wavesurfer) return;

    const subscriptions = [
      wavesurfer.on("ready", () => {
        wavesurfer.setVolume(volume / 100);
        if (playing) {
          wavesurfer.play().catch((e) => {
            if (e.name !== "AbortError") console.error(e);
          });
        }
        handleCurrentTime && handleCurrentTime(0);
        handlePlay && handlePlay(true);
      }),
      wavesurfer.on("play", () => {
        handlePlay && handlePlay(true);
      }),
      wavesurfer.on("pause", () => {
        handlePause && handlePause(false);
      }),
        wavesurfer.on("timeupdate", (currentTime) => {
          if (handleCurrentTime) {
            const duration = wavesurfer.getDuration ? wavesurfer.getDuration() : 0;
            handleCurrentTime(currentTime, duration);
          }
        }),
      wavesurfer.on("interaction", (currentTime) => {
        handleSeek && handleSeek(currentTime);
      }),
      wavesurfer.on("finish", () => {
        handleEnd && handleEnd();
      }),
    ];

    return () => {
      subscriptions.forEach((unsub) => unsub());
    };
  }, [wavesurfer, url, volume, handlePlay, handlePause, handleCurrentTime, handleSeek, handleEnd, playing]);

  return (
    <Box
      sx={{
        width: "100%",
        py: 2,
        px: 0,
        mb: 2,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
      }}
    >
      <div
        ref={containerRef}
        style={{
          width: "100%",
          maxWidth: 600,
          height: 64,
          minHeight: 48,
          margin: "0 auto",
          borderRadius: 8,
        }}
      />
    </Box>
  );
}